var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3733 22.0373C68.64 19.874 66.5867 18.334 64.1667 18.334H23.8333C21.4133 18.334 19.3967 19.874 18.6267 22.0373L11 44.0007V73.334C11 75.3506 12.65 77.0006 14.6667 77.0006H18.3333C20.35 77.0006 22 75.3506 22 73.334V69.6673H66V73.334C66 75.3506 67.65 77.0006 69.6667 77.0006H73.3333C75.35 77.0006 77 75.3506 77 73.334V44.0007L69.3733 22.0373ZM23.8333 58.6673C20.79 58.6673 18.3333 56.2106 18.3333 53.1673C18.3333 50.124 20.79 47.6673 23.8333 47.6673C26.8767 47.6673 29.3333 50.124 29.3333 53.1673C29.3333 56.2106 26.8767 58.6673 23.8333 58.6673ZM64.1667 58.6673C61.1233 58.6673 58.6667 56.2106 58.6667 53.1673C58.6667 50.124 61.1233 47.6673 64.1667 47.6673C67.21 47.6673 69.6667 50.124 69.6667 53.1673C69.6667 56.2106 67.21 58.6673 64.1667 58.6673ZM18.3333 40.334L23.8333 23.834H64.1667L69.6667 40.334H18.3333Z",
    fill: "#E1E1E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarList);
export default __webpack_public_path__ + "static/media/car-list.c7db8e79b9a7602efd2f855467892acc.svg";
export { ForwardRef as ReactComponent };